import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./MassMailing.module.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { customTextColor } from "../../utils/const";
import profile_image from "../../assets/images/ajit_image.jpeg";

const job = [
  { value: "fulltime", label: "Fulltime" },
  { value: "contract", label: "Contract" },
  { value: "w2", label: "W2" },
];

const location = [
  { value: "pst", label: "PST" },
  { value: "california", label: "California" },
  { value: "taxes", label: "Texas" },

];

const work = [
  { value: "gc", label: "GC" },
  { value: "usc", label: "USC" },
];

const preference = [
  { value: "onsite", label: "Onsite" },
  { value: "hybrid", label: "Hybrid" },
  { value: "remote", label: "Remote" },
];

const authorization = [
  { value: "gc", label: "GC" },
  { value: "usc", label: "USC" },
  { value: "opt", label: "OPT" },
];

const currencies = [
  {
    value: 'pst',
    label: 'PST',
  },
  {
    value: 'mst',
    label: 'MST',
  },
  {
    value: 'cst',
    label: 'CST',
  },
  {
    value: 'est',
    label: 'EST',
  },
  {
    value: 'opentowork',
    label: 'Open to Work',
  },
];




const customStyle = { width: "100%", padding: '3px', "& .MuiInputLabel-root": { fontSize: '14px' } }
const PostJobRequirement = () => {

  const [jobType, setJobType] = useState("");

  const handleJobTypeChange = (event) => {
    setJobType(event.target.value);
  };
  const navigate = useNavigate();
  return (
    // <RootComponents>
      <Box className={styles.candidate_structure}>
        <Box className={styles.job_serach_result_heading}>
          <Typography sx={{ color: customTextColor }}>
            Instant Mass Mailing Portal – New Email
          </Typography>

        </Box>



       
        <Grid container sx={{ backgroundColor: '#fff', paddingBottom: '10px' }}>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ padding: "7px 15px 0" }}>
              <TextField

                variant="standard"
                label="Subject"
                   sx={customStyle}
                InputLabelProps={{
                  sx: { marginLeft: "10px" },
                }}
              />

            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
              <TextField

                variant="standard"
                label="Job Title"
                   sx={customStyle}
                InputLabelProps={{
                  sx: { marginLeft: "10px" },
                }}
              />


            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
              <TextField

                variant="standard"
                label="Experience"
                   sx={customStyle}
                InputLabelProps={{
                  sx: { marginLeft: "10px" },
                }}
              />


            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
              <TextField
                select
                variant="standard"
                label="Mode of Hiring"
                   sx={customStyle}
                InputLabelProps={{
                  sx: { marginLeft: "10px" },
                }}
              >
                {job.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
              <TextField
                select
                variant="standard"
                label="Work Preference"
                   sx={customStyle}
                InputLabelProps={{
                  sx: { marginLeft: "10px" },
                }}
              >
                {preference.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
              <TextField
                select
                variant="standard"
                label="Location"
                   sx={customStyle}
                InputLabelProps={{
                  sx: { marginLeft: "10px" },
                }}
              >
                {location.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
              <TextField
                select
                variant="standard"
                label="Work Authorization"
                   sx={customStyle}
                InputLabelProps={{
                  sx: { marginLeft: "10px" },
                }}
              >
                {authorization.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0" }}>
              <TextField

                variant="standard"
                label="Mail from"
                   sx={customStyle}
                InputLabelProps={{
                  sx: { marginLeft: "10px" },
                }}
              />


            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: "7px 15px 0"  }}>
              <TextField

                variant="standard"
                label="Replay to"
                   sx={customStyle}
                InputLabelProps={{
                  sx: { marginLeft: "10px" },
                }}
              />

            </Grid>  
          </Grid>
          <Box className={styles.mandatory_description}>
              <Box sx={{ color: customTextColor }}>
                {/* <Typography sx={{ padding: '0 5px 30px 0' }}>Job description</Typography> */}
                <textarea class="form-control" id="exampleFormControlTextarea1" rows="5" placeholder="Job description" 
                
                  style={{ overflow: 'hidden', resize: 'none', border: 'none' }}></textarea>
                <hr style={{ marginBottom: '0' }}></hr>
                {/* <Typography >Mandatory Skills</Typography> */}
                <textarea style={{ border: 'none' }} class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Mandatory Skills"></textarea>
              </Box>

            </Box>
         
            <div style={{ backgroundColor: '#fff', padding: '1px 17px 14px ' }}>
              <Box className={styles.recruiter_profile}>
                <div >
                  <img src={profile_image} alt="" />
                  <span style={{ color: customTextColor }}>
                    <Typography style={{ marginBottom: '12px ' }}>
                      <b>  Thanks & Regrads  </b>
                    </Typography>
                    <Typography>
                      <b> Ajit Kumar Gahan</b>
                    </Typography>
                    <Typography>
                      UI Designer at Tek Inspiration
                    </Typography>
                    <Typography sx={{ margin: "0 !important" }}>
                      E-mail: Ajit@tekinspirations.com,   Ph : 77012 54720
                    </Typography>

                  </span>
                </div>
              </Box>
            </div>
       


    


      

        <Box className={styles.new_update_btns}>
          <button  style={{ marginLeft: "15px", backgroundColor: "#4285f4" }}>
            Send to Bench Sales
          </button>
          <Box>
            <span className={styles.send_update_btns}>
            <button 
               style={{ backgroundColor: "#3856a6", marginRight:'0' }}onClick={() => navigate("/mass-mailing-sales-recruiter")}>
              Send to Both
            </button>
            </span>
          </Box>
        </Box>
      </Box>

    // </RootComponents>
  );
};

export default PostJobRequirement;
